import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import { FormConfig } from '../../definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  options: any = {};

  generateForm(entity: PledgeProductRead & { parameters: any }, options) {
    this.options = options;

    let supportRepartition: UntypedFormGroup[] = [];

    const supportRepartitionIsin = entity?.parameters?.supportRepartition;
    if (supportRepartitionIsin)
      _.forEach(supportRepartitionIsin, (scpi, i) =>
        supportRepartition.push(this.formBuilder.group(this.createModel(scpi))),
      );

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avDistribution: [entity.parameters?.avDistribution || null],
        supportRepartition: this.formBuilder.array(
          supportRepartition,
          entity?.parameters?.avDistribution === 'PILOTED'
            ? Validators.maxLength(1)
            : Validators.nullValidator,
        ),
      }),
    };

    return this.formBuilder.group(formConfig, {});
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  get supportRepartition() {
    return this.products
      .get(`${0}`)
      .get('parameters')
      .get('supportRepartition') as UntypedFormArray;
  }
  public createModel(item): any {
    const model = {
      id: [item?.id || null],
      isin: [item?.isin || item?.supportIsin || null],
      index: [item?.index || null],
      omniprodId: [item?.omniProductId || item?.omniprodId || null],
      name: [item?.name || null],
      initalRepartition: [item?.initalRepartition || null],
      monthlyRepartition: [item?.monthlyRepartition || null],
      favorite: [item?.favorite || null],
      type: [item?.type || null],
      supportDescription: [this.options?.supportDescription || null],
      totalInvestedAmount: [this.options?.initialDeposit || null],
      riskScore: [item?.riskScore || null],
    };

    return model;
  }

  extract() {
    const formValue =
      this.form.value?.products?.[0]?.parameters?.supportRepartition;

    const supportRepartition = this.extractSupportRepartition(formValue);

    const supportRepartitionIsin = this.pickOnlyIsin(supportRepartition);

    const products = this.form.value?.products;
    const productsIsin = this.modifyProductsWithRepartition(
      products,
      supportRepartitionIsin,
    );

    return productsIsin;
  }

  private modifyProductsWithRepartition(
    products: any,
    supportRepartitionIsin: {
      isin: any;
      name: any;
      initalRepartition: number;
      monthlyRepartition: number;
      type: any;
    }[],
  ) {
    return _.map(products, o => {
      return {
        ...o,
        parameters: {
          ...o.parameters,
          supportRepartition: supportRepartitionIsin,
          productPackId: null,
        },
      };
    });
  }

  private pickOnlyIsin(supportRepartition: any[]) {
    return _.map(supportRepartition, o => {
      return {
        isin: o.isin,
        name: o.name,
        initalRepartition: 0,
        monthlyRepartition: 0,
        type: o.type,
        riskScore: o?.riskScore || null,
      };
    });
  }

  private extractSupportRepartition(formValue: any) {
    return _.filter(formValue, o => {
      return o.isin != undefined || o.isin != null;
    });
  }
}
